import React from "react";
import { Routes, Route } from "react-router-dom";
import Lostroute from "../../pages/LostRoute/Lostroute";
import Home from "../../pages/Home/Home";
import Logs from "../../pages/Home/Logs";

export const commonRoutes = [
  {
    path: "/home",
    element: <Home />,
  },
  {
    path: "/home/s3",
    element: <Logs />,
  },
  {
    path: "*",
    element: <Lostroute />,
  },
  {
    path: "/noLicence",
    element: <Lostroute />,
  },
];

const NavigationRoutes = () => {
  return (
    <Routes>
      {commonRoutes.map(({ path, element }) => {
        return <Route path={path} element={element} key={path} />;
      })}
    </Routes>
  );
};

export default NavigationRoutes;
